import { combineReducers } from 'redux';
import modalReducer from '../modal-container/modal-reducer';
import activeFiltersReducer from '../../components/report-filters/redux/active-filters/active-filters-reducer';
import activityMasteryAllClassesReducer from '../activity-mastery/all-classes/all-classes-reducer';
import activityMasterySingleClassReducer from '../activity-mastery/single-class/single-class-reducer';
import activityMasteryStudentReducer from '../activity-mastery/student/student-reducer';
import participationAllClassesReducer from '../participation/all-classes/all-classes-reducer';
import participationSingleClassReducer from '../participation/single-class/single-class-reducer';
import participationStudentReducer from '../participation/student/student-reducer';
import selectedImprovementsReducer from '../participation/student/selected-improvements-reducer';
import liveMathsAllClassesReducer from '../live-maths/all-classes/all-classes-reducer';
import liveMathsSingleClassReducer from '../live-maths/single-class/single-class-reducer';
import liveMathsStudentReducer from '../live-maths/student/student-reducer';
import skillQuestsMasteryAllClassesReducer from '../skill-quests-mastery/all-classes/all-classes-reducer';
import skillQuestsMasterySingleClassReducer from '../skill-quests-mastery/single-class/single-class-reducer';
import skillQuestsMasteryStudentReducer from '../skill-quests-mastery/student/student-reducer';
import academicYearReducer from '../../components/report-filters/redux/academic-year/academic-year-reducer';
import allClassesReducer from '../../components/report-filters/redux/class-list/class-list-reducer';
import studentsByGroupReducer from '../../components/report-filters/redux/students-by-group/students-by-group-reducer';
import busyIndicatorReducer from '../../components/busy-indicator/busy-indicator-reducer';
import errorsReducer from './errors/errors-reducer';
import invalidRequestReducer from './errors/invalid-request-reducer';
import exportedReportReducer from '../../components/sub-heading/export-report/export-report-reducer';
import hasLifetimeDataReducer from '../../components/report-filters/redux/has-lifetime-data/has-lifetime-data-reducer';
import sessionIdReducer from './session-id/session-id-reducer';
import liveMathsLevelReducer from '../../components/live-maths-level-picker/live-maths-level-reducer';
import isAdminReducer from '../../components/report-filters/redux/is-admin/is-admin-reducer';
import dropdownDataReducer from '../../components/report-filters/redux/dropdown-data/dropdown-data-reducer';
import yearGroupsReducer from '../../components/report-filters/redux/year-groups/year-groups-reducer';
import reportStateReducer from '../participation/all-classes/report-state/report-state-reducer';
import studentClassesReducer from '../participation/all-classes/student-classes/student-classes-reducer';
import downloadReportReducer from '../../components/sub-heading/download-report/download-report-reducer';
import formatReportReducer from '../../components/sub-heading/format-picker/format-picker-reducer';
import assignmentResultReducer from '../../components/assignment-result/assignment-result-reducer';
import gemsReducer from '../../components/certificates/gems-reducer';

const CombinedReducers = combineReducers({
    /* activity mastery */
    activityMasteryAllClasses: activityMasteryAllClassesReducer,
    activityMasterySingleClass: activityMasterySingleClassReducer,
    activityMasteryStudent: activityMasteryStudentReducer,

    /* participation */
    participationAllClasses: participationAllClassesReducer,
    reportState: reportStateReducer,
    studentClasses: studentClassesReducer,
    participationSingleClass: participationSingleClassReducer,
    participationStudent: participationStudentReducer,
    selectedImprovements: selectedImprovementsReducer,

    /* live maths */
    liveMathsAllClasses: liveMathsAllClassesReducer,
    liveMathsSingleClass: liveMathsSingleClassReducer,
    liveMathsStudent: liveMathsStudentReducer,
    liveMathsLevel: liveMathsLevelReducer,

    /* skill quests mastery */
    skillQuestsMasteryAllClasses: skillQuestsMasteryAllClassesReducer,
    skillQuestsMasterySingleClass: skillQuestsMasterySingleClassReducer,
    skillQuestsMasteryStudent: skillQuestsMasteryStudentReducer,

    /* filters */
    activeFilters: activeFiltersReducer,
    academicYear: academicYearReducer,
    yearGroups: yearGroupsReducer,
    allClasses: allClassesReducer,
    studentsByGroup: studentsByGroupReducer,
    hasLifetimeData: hasLifetimeDataReducer,
    isAdmin: isAdminReducer,
    dropdownData: dropdownDataReducer,
    assignmentResultType: assignmentResultReducer,
    gemsDetails: gemsReducer,

    /* export */
    exportedReport: exportedReportReducer,
    downloadReport: downloadReportReducer,
    formatReport: formatReportReducer,

    /* fundamentals */
    modalMessages: modalReducer,
    busyIndicatorCount: busyIndicatorReducer,
    errors: errorsReducer,
    invalidRequest: invalidRequestReducer,
    sessionId: sessionIdReducer
});

export default CombinedReducers;



// WEBPACK FOOTER //
// ./containers/app/combined-reducers.js